import R from "ramda";
import { store } from "store";
import { batchChangeViewedSetting, putDocument } from "api/documents";
import { reloadDocuments } from "actions/documents-actions";
import { setFlashMessageAction, setFlashGenericErrorAction } from "actions/app-actions";
import { trackEventAction } from "actions/shared/tracking-actions";

export const FOCUS_DOCUMENT = "actions/documents/focus-document";
export const UNFOCUS_DOCUMENT = "actions/documents/unfocus-document";
export const SAVE_DOCUMENT = "actions/documents/save-document";
export const REMOVE_CATEGORY = "actions/documents/remove-category";
export const REPROCESS_DOCUMENT = "actions/documents/reprocess-document";
export const CHANGE_DOCUMENT_TYPE = "actions/documents/change-document-type";
export const UPDATE_DOCUMENT_INLINE = "actions/documents/update-document-inline";
export const UPDATE_DOCUMENT = "actions/documents/update-document";
export const UPDATE_PAYMENT_TYPE = "actions/documents/update-payment-type";

export const removeCategoryAction = (category) => ({
  type: REMOVE_CATEGORY,
  data: { category }
});

export const focusDocumentAction = (row, style) => ({
  type: FOCUS_DOCUMENT,
  data: { row, style }
});

export const unfocusDocumentAction = () => ({ type: UNFOCUS_DOCUMENT });

export const saveDocumentAction = () => (dispatch) => {
  const state = store.getState();
  const accountId = state.app.selectedAccount.id;
  const document = state.updateDocument;
  document.name = document.vendor;
  return putDocument(accountId, document.id, document)
    .then(() => {
      dispatch({
        type: SAVE_DOCUMENT,
        data: { document }
      });
      dispatch(trackEventAction("Document saved"));
      dispatch(setFlashMessageAction("Document saved."));
    });
};

export const reprocessDocumentAction = (accountId) => (dispatch) => {
  const document = store.getState().updateDocument;
  const newDocument = R.clone(document);
  newDocument.processingState = "NEEDS_SYSTEM_PROCESSING";
  putDocument(accountId, document.id, newDocument)
    .then(() => {
      dispatch({
        type: REPROCESS_DOCUMENT,
        data: { newDocument }
      });
    })
    .then(() => {
      dispatch(unfocusDocumentAction());
      reloadDocuments(dispatch);
      dispatch(trackEventAction("Document reprocessed"));
    })
    .catch(() => dispatch(setFlashGenericErrorAction()));
};

export const trashDocumentAction = (accountId, document) => (dispatch) => {
  putDocument(accountId, document.id, R.assoc("trashed", true, document))
    .then(() => {
      dispatch(unfocusDocumentAction());
      reloadDocuments(dispatch);
      dispatch(trackEventAction("Document trashed"));
    })
    .catch(() => dispatch(setFlashGenericErrorAction()));
};

export const changeDocumentTypeAction = (accountId) => (dispatch) => {
  const state = store.getState();
  const document = state.updateDocument;
  const defaultCurrency = state.accountSettings.currency;
  const newDocument = getDocumentForChange(document, defaultCurrency);
  putDocument(accountId, document.id, newDocument)
    .then(() => {
      dispatch(unfocusDocumentAction());
      reloadDocuments(dispatch);
      dispatch(trackEventAction("Document type changed"));
    })
    .catch(() => dispatch(setFlashGenericErrorAction()));
};

const getDocumentForChange = (document, defaultCurrency) => {
  if (document.type === "receipt") {
    return R.merge(document, { name: document.vendor, type: "other" });
  }
  return R.merge(document, {
    currency: document.currency || defaultCurrency,
    vendor: document.name,
    type: "receipt"
  });
};

export const submitChangeViewedSettingAction = (isViewed) => (dispatch) => {
  const state = store.getState();
  const account = state.app.selectedAccount;
  const documentIds = R.path(["documents", "selectedDocumentIds"], state);
  const documents = R.path(["documents", "documents"], state);
  const selectedDocuments = documentIds.map(id => documents.find(document => document.id === id));
  dispatch(trackEventAction("Viewed setting changed"));

  return batchChangeViewedSetting(account.id, selectedDocuments, isViewed)
    .then(() => reloadDocuments(dispatch, false))
    .catch(() => dispatch(setFlashGenericErrorAction()));
};

export const updateInlineDocumentAction = ({ accountId, document, field, value }) => (dispatch) => {
  const newDocument = R.set(R.lensProp(field), value, document);
  return putDocument(accountId, document.id, newDocument)
  .then(() => {
    dispatch({
      type: UPDATE_DOCUMENT_INLINE,
      data: { document: newDocument, field, value }
    });
  });
};

export const updateDocumentAction = (field, value) => ({
  type: UPDATE_DOCUMENT,
  data: { field, value }
});

export const updatePaymentTypeAction = (field, value) => ({
  type: UPDATE_PAYMENT_TYPE,
  data: { field, value }
});



// WEBPACK FOOTER //
// ./src/js/actions/update-document-actions.js